module.exports = __webpack_public_path__ + "img/international-header.4c2cc542.png";